import auth from "@/middleware/auth";
import { routes as cadastro } from "./cadastro/";
import { routes as meusBoletos } from "./meusBoletos/";
import { routes as propostas } from "./propostas/";
import { routes as propostasCdc } from "./propostasCdc/";
import { routes as propostasConsorcio } from "./propostasConsorcio/";
import { routes as propostasContencioso } from "./propostasContencioso/";
import { routes as propostasFianca } from "./propostasFianca/";
import { routes as resumoAcordo } from "./resumoAcordo/";
import { routes as resumoAcordoCdc } from "./resumoAcordoCdc/";
import { routes as resumoAcordoConsorcio } from "./resumoAcordoConsorcio/";


export default [
    {
        path: "/dashboard",
        component: () => import("@/modules/layout/DashboardLayout"),
        children: [
            {
                path: "/",
                name: "dashboard",
                meta: { middleware: [auth] },
                component: () => import("./Dashboard")
            },
            ...cadastro,
            ...meusBoletos,
            ...propostas,
            ...propostasCdc,
            ...propostasConsorcio,
            ...propostasContencioso,
            ...propostasFianca,
            ...resumoAcordo,
            ...resumoAcordoCdc,
            ...resumoAcordoConsorcio,
        ],
    },
];
